/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';
import styled from 'styled-components';
import { BASE_FONT_BOLD_WEIGHT, Text, SPACING_S, SPACING_XL } from '@veeam/components';

import type { CSSProperties } from 'react';

export interface FieldsetTitleProps {
    title: React.ReactNode;
    titleStyles?: CSSProperties;
}

const FieldsetTitleBase = styled(Text)`
    padding-left: ${SPACING_S};
    font-weight: ${BASE_FONT_BOLD_WEIGHT};
    line-height: ${SPACING_XL};
    background-color: ${({ theme }) => theme.colorBackgroundNeutralLight};
`;

export const FieldsetTitle: React.FC<FieldsetTitleProps> = ({ title, titleStyles }) => (
    <FieldsetTitleBase style={{ ...titleStyles }}>{title}</FieldsetTitleBase>
);
